export const GraphEndpoints: { [key: number]: string } = {
  1: 'https://api.thegraph.com/subgraphs/name/predy-dev/predy',
  42: 'https://api.thegraph.com/subgraphs/name/predy-dev/predykovan',
  80001: 'https://api.thegraph.com/subgraphs/name/predy-dev/predymumbai'
}
